import { Link } from "react-router-dom";
import { featuredArticles, latestArticles } from "@/mocks/articles";
import { getChannel } from "@/mocks/channels";
import { formatDate, formatViews, toneSoft } from "@/utils/display";

export default function HeroSection() {
  const [lead, ...rest] = featuredArticles();
  const side = latestArticles(4).filter((a) => a.slug !== lead?.slug).slice(0, 4);

  if (!lead) return null;

  const channel = getChannel(lead.channel);
  const tone = channel?.tone ?? "primary";

  return (
    <section aria-label="焦点档案" className="border-b border-background-200 bg-background-100">
      <div className="container-page grid grid-cols-1 gap-6 py-8 lg:grid-cols-[1.55fr_1fr] lg:py-12">
        <article className="group relative overflow-hidden rounded-lg animate-rise">
          <Link to={`/article/${lead.slug}`} className="block h-[380px] w-full md:h-[480px]">
            <img
              src={lead.cover}
              alt={`${lead.title} 配图`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-foreground-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  本期头条
                </span>
                {channel && (
                  <span className="rounded-md bg-background-50/15 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
                    {channel.name}
                  </span>
                )}
              </div>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
                {lead.title}
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
                {lead.excerpt}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-300">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line" aria-hidden="true" />
                  {lead.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line" aria-hidden="true" />
                  {formatDate(lead.publishedAt)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {formatViews(lead.views)}
                </span>
              </div>
            </div>
          </Link>
        </article>

        <div className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <div className="flex items-center justify-between">
            <h2 className="font-heading text-lg font-bold text-foreground-950">最新收录</h2>
            <span className="flex items-center gap-1 text-xs text-primary-700">
              <i className="ri-history-line" aria-hidden="true" />
              实时更新
            </span>
          </div>
          <div className="mt-3 flex flex-1 flex-col">
            {side.map((a, index) => {
              const c = getChannel(a.channel);
              return (
                <article
                  key={a.slug}
                  className="group flex items-start gap-3 border-b border-background-200 py-4 last:border-b-0"
                >
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                      toneSoft[c?.tone ?? tone]
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-sm font-medium leading-snug text-foreground-900">
                      <Link
                        to={`/article/${a.slug}`}
                        className="transition-colors hover:text-primary-700"
                      >
                        {a.title}
                      </Link>
                    </h3>
                    <p className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                      <span>{c?.name}</span>
                      <span>{formatDate(a.publishedAt)}</span>
                    </p>
                  </div>
                </article>
              );
            })}
          </div>
          <Link
            to="/channels"
            className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览全部栏目
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}